import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=07547bfa&scoped=true"
import script from "./queue.vue?vue&type=script&lang=js"
export * from "./queue.vue?vue&type=script&lang=js"
import style0 from "./queue.vue?vue&type=style&index=0&id=07547bfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07547bfa",
  null
  
)

export default component.exports